import React from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import withRouter from './WithRouter';
import classnames from 'classnames';
import { addOrganization, listOrganizations } from '../actions/organization';
import { Button, Input } from 'rsuite';

var z = 0


class Organizations extends React.Component {

  constructor() {
      super();
      this.state = {
          name: '',
          errors: {},
          list: []
      }
      this.handleInputChange = this.handleInputChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
  }
  componentDidMount() {

      this.timeout = setInterval(() => {
        this.props.listOrganizations('dada', this.props.history);
      }, 10000)

  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  handleInputChange(n, v ) {
      this.setState({
          [n]: v
      })
  }

  handleSubmit(e) {
      e.preventDefault();
      const organization = {
          name: this.state.name
      }
      this.props.addOrganization(organization, this.props.history);
  }

    render() {
      const { errors } = this.state;
      return (
          <div className="component organizations">
            <h1>Organizations</h1>
              <form onSubmit={ this.handleSubmit }>
                  <div className="form-group">
                      <Input
                      type="text"
                      placeholder="Name"
                      autoComplete="name"
                      className={classnames('form-control form-control-lg', {
                          'is-invalid': errors.name
                      })}
                      name="name"
                      onChange={value => {
                        this.handleInputChange('name', value);
                      }}
                      value={ this.state.name }
                      />
                      {errors.name && (<div className="invalid-feedback">{errors.name}</div>)}
                  </div>
                  <div className="form-group">
                      <Button appearance="primary" type="submit" className="btn btn-primary iron-button">
                          Add organization
                      </Button>
                  </div>
              </form>
              <ul className="list">
                {
                  this.props.organizations.list.map((organization, i) => (
                    <li key={organization._id} className="organization">
                      <div className="left">
                        <div className="top-line">
                          <div className="device_name">{organization.name}</div>
                        </div>
                      </div>
                      <div className="details">
                        <div className="right">
                          Szczegóły
                        </div>
                      </div>
                    </li>
                  ))
                }
              </ul>
          </div>
      );
    }
}

Organizations.propTypes = {
    addOrganization: PropTypes.func.isRequired,
    listOrganizations: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    organizations: state.organizations,
    auth: state.auth,
    errors: state.errors
});

export default connect(mapStateToProps,{ addOrganization, listOrganizations })(withRouter(Organizations))
